import { z as e } from "zod";
import { computed as t, readonly as n, ref as r, toRefs as i } from "vue";
import { defineStore as a } from "pinia";
//#region src/schemas/environment.schema.ts
var o = ["production", "acceptance"], s = e.enum(o), c = e.union([
	e.literal("BOL"),
	e.literal("BPOST"),
	e.literal("CHEAP_CARGO"),
	e.literal("INSTABOX"),
	e.literal("DHL_EUROPLUS"),
	e.literal("DHL_FOR_YOU"),
	e.literal("DHL_PARCEL_CONNECT"),
	e.literal("DPD"),
	e.literal("GLS"),
	e.literal("POSTNL"),
	e.literal("UPS_EXPRESS_SAVER"),
	e.literal("UPS_STANDARD"),
	e.literal("TRUNKRS"),
	e.literal("BRT"),
	e.literal("INPOST"),
	e.literal("POSTE_ITALIANE"),
	e.literal("SPRING"),
	e.literal("VIA_TIM"),
	e.literal("DHL_FREIGHT")
]), l = e.union([
	e.literal("BOL"),
	e.literal("SHOPIFY"),
	e.literal("WOOCOMMERCE"),
	e.literal("LIGHTSPEED"),
	e.literal("PRESTA"),
	e.literal("CSCART")
]), u = e.union([
	e.literal("PACKAGE"),
	e.literal("MAILBOX"),
	e.literal("UNFRANKED"),
	e.literal("DIGITAL_STAMP"),
	e.literal("SMALL_PACKAGE"),
	e.literal("PALLET"),
	e.literal("LETTER"),
	e.literal("ENVELOPE")
]), d = e.union([
	e.literal("DOMESTIC"),
	e.literal("EU"),
	e.literal("NON_EU")
]), f = e.union([
	e.literal("EVENING_DELIVERY"),
	e.literal("EXPRESS_DELIVERY"),
	e.literal("MORNING_DELIVERY"),
	e.literal("PICKUP_DELIVERY"),
	e.literal("PICKUP_EXPRESS_DELIVERY"),
	e.literal("SAME_DAY_DELIVERY"),
	e.literal("STANDARD_DELIVERY")
]), p = e.union([
	e.literal("AGE_CHECK"),
	e.literal("COLLECT"),
	e.literal("COOLED_DELIVERY"),
	e.literal("DROP_OFF_AT_POSTAL_POINT"),
	e.literal("EXTRA_ASSURANCE"),
	e.literal("HIDE_SENDER"),
	e.literal("LARGE_FORMAT"),
	e.literal("ONLY_RECIPIENT"),
	e.literal("RECEIPT_CODE"),
	e.literal("RETURN"),
	e.literal("SAME_DAY_DELIVERY"),
	e.literal("SATURDAY_DELIVERY"),
	e.literal("SIGNATURE"),
	e.literal("TRACKED")
]), m = e.union([
	e.literal("labelDescriptionLength"),
	e.literal("carrierSmallPackageContract"),
	e.literal("multiCollo"),
	e.literal("needsCustomerInfo")
]), h = e.union([
	e.literal("username"),
	e.literal("password"),
	e.literal("api_key"),
	e.literal("api_key_2"),
	e.literal("options.customerNumber"),
	e.literal("options.companyName"),
	e.literal("options.sendingDepot"),
	e.literal("options.departureDepot"),
	e.literal("ddp_clear"),
	e.literal("ddp_standard")
]), g = e.union([h, e.strictObject({
	name: h.meta({ description: "Key the parameter is submitted under. A dot-separated name such as `options.companyName` nests the value under that object in the carrier option payload." }),
	optional: e.boolean().optional().meta({ description: "Whether the customer may leave the parameter empty. Parameters are required unless this is true." })
})]), _ = e.union([
	e.literal("analytics"),
	e.literal("extraPerReturn"),
	e.literal("reasons"),
	e.literal("returnsPerMonth"),
	e.literal("rules")
]), v = e.union([
	e.literal("advancedAnalysis"),
	e.literal("avoidSurcharges"),
	e.literal("cases"),
	e.literal("claims"),
	e.literal("compareQuality"),
	e.literal("dailyReport"),
	e.literal("delays"),
	e.literal("deliveryPredictions"),
	e.literal("downloadGraphs"),
	e.literal("exportData"),
	e.literal("insightFinances"),
	e.literal("performanceBenchmark"),
	e.literal("shipmentLevel"),
	e.literal("surcharges"),
	e.literal("transitTime"),
	e.literal("volumePredictions"),
	e.literal("weekReport")
]), y = e.union([
	e.literal("bulkEdit"),
	e.literal("extraLabelFee"),
	e.literal("labelsIncludedPerMonth"),
	e.literal("returnRules"),
	e.literal("shipmentsIncludedPerMonth")
]), b = e.union([
	e.literal("automatedRules"),
	e.literal("divide"),
	e.literal("import"),
	e.literal("label"),
	e.literal("notes"),
	e.literal("picking"),
	e.literal("printCloud"),
	e.literal("printPickingLists")
]), ee = e.union([
	e.literal("browser"),
	e.literal("extraPrints"),
	e.literal("included"),
	e.literal("scanner")
]), te = e.strictObject({
	packageTypes: e.array(u),
	deliveryTypes: e.array(f),
	shipmentOptions: e.array(p),
	metadata: e.record(m, e.union([
		e.boolean(),
		e.number(),
		e.string()
	]))
}), ne = e.discriminatedUnion("type", [e.strictObject({
	type: e.literal("dimensions"),
	value: e.number()
})]), x = e.strictObject({
	id: e.number().int().optional(),
	carrier: e.strictObject({
		id: e.number().int(),
		name: c
	}),
	configurationParameters: e.array(g).optional()
}), S = e.strictObject({
	type: e.union([e.literal("MAIN"), e.literal("CUSTOM")]),
	carrier: c
}), re = e.strictObject({
	language: e.string(),
	supportedLanguages: e.array(e.string()),
	timezone: e.string(),
	dateFormats: e.record(e.string(), e.string())
}), ie = e.strictObject({
	documents: e.strictObject({
		termsAndConditionsUrl: e.string(),
		privacyStatementUrl: e.string(),
		cookieStatementUrl: e.string(),
		scanSheetUrl: e.string()
	}),
	faq: e.strictObject({
		postalCode: e.string(),
		directPrinting: e.string(),
		userManagement: e.strictObject({ roleExplanationUrl: e.string() })
	}),
	directPrinting: e.strictObject({ printApplicationDownloadUrls: e.strictObject({
		windows: e.string(),
		mac: e.string()
	}) }),
	manuals: e.strictObject({ myContracts: e.strictObject({
		DHL_FOR_YOU: e.string().optional(),
		DHL_PARCEL_CONNECT: e.string().optional(),
		DHL_EUROPLUS: e.string().optional(),
		DPD: e.string().optional(),
		UPS_STANDARD: e.string().optional(),
		UPS_EXPRESS_SAVER: e.string().optional(),
		GLS: e.string().optional(),
		BRT: e.string().optional(),
		TRUNKRS: e.string().optional(),
		INPOST: e.string().optional(),
		SPRING: e.string().optional()
	}) }),
	finance: e.strictObject({
		carrierComparePriceUrl: e.string(),
		priceScalesPolicy: e.string(),
		tariffUrl: e.string(),
		invoiceTooltipUrl: e.string()
	}),
	returns: e.string(),
	authenticators: e.record(e.string(), e.strictObject({
		name: e.string(),
		url: e.string()
	})),
	externalIntegrationSupportUrls: e.strictObject({
		amazon: e.string(),
		bol_dot_com: e.string(),
		etsy: e.string(),
		exact: e.string(),
		lightspeed: e.string().meta({ description: "Documentation URL explaining how to set up a Lightspeed sales channel via the backoffice." }),
		prestashop: e.string().meta({ description: "Documentation URL explaining how to set up a PrestaShop sales channel via the backoffice." }),
		shopify: e.string().meta({ description: "Documentation URL explaining how to set up a Shopify sales channel via the backoffice." }),
		wix: e.string(),
		woocommerce: e.string().meta({ description: "Documentation URL explaining how to set up a WooCommerce sales channel via the backoffice." })
	}),
	orders: e.strictObject({ volumetricWeightLink: e.strictObject({
		UPS: e.string(),
		POSTNL: e.string()
	}) }),
	subscriptions: e.strictObject({
		comparePricesUrl: e.string(),
		compareFunctionalityUrl: e.string(),
		myAnalytics: e.strictObject({ moreInfoUrl: e.string() }),
		myContracts: e.strictObject({ moreInfoUrl: e.string() }),
		myOrders: e.strictObject({ moreInfoUrl: e.string() }),
		myScanAndPrint: e.strictObject({ moreInfoUrl: e.string() })
	}),
	termsAndConditions: e.strictObject({ dpd: e.string() }),
	shipments: e.strictObject({ goodsImportExportFormUrl: e.string().meta({ description: "External URL of the goods import/export quote request form, linked from the import/export shipment-create tab. Only set on propositions where goods import/export is enabled." }) }).optional()
}), ae = e.discriminatedUnion("enabled", [e.strictObject({
	enabled: e.literal(!0),
	url: e.url()
}), e.strictObject({ enabled: e.literal(!1) })]), oe = e.union([
	e.literal("transitTime"),
	e.literal("deliveryTo"),
	e.literal("handover"),
	e.literal("dimensions"),
	e.literal("weight"),
	e.literal("trackAndTrace"),
	e.literal("insurance"),
	e.literal("shipmentOptions"),
	e.literal("customDelivery"),
	e.literal("surcharge")
]), se = e.strictObject({
	proposition: e.strictObject({
		id: e.number().int(),
		key: e.string(),
		name: e.string(),
		shortName: e.string()
	}),
	contract: S,
	carrierSortOrder: e.array(c),
	addressBook: e.strictObject({
		enableCollectAddress: e.boolean(),
		enableCreateReturnShipments: e.boolean()
	}),
	applications: e.strictObject({
		webshop: ae,
		faq: ae,
		developerPortal: e.discriminatedUnion("enabled", [e.strictObject({
			enabled: e.literal(!0),
			url: e.url(),
			pages: e.strictObject({ apiReference: e.url() })
		}), e.strictObject({ enabled: e.literal(!1) })]),
		corporate: ae,
		backoffice: e.discriminatedUnion("enabled", [e.strictObject({
			enabled: e.literal(!0),
			url: e.url(),
			internationalization: re
		}), e.strictObject({ enabled: e.literal(!1) })]),
		consumerPortal: e.discriminatedUnion("enabled", [e.strictObject({
			enabled: e.literal(!0),
			url: e.url(),
			internationalization: re
		}), e.strictObject({ enabled: e.literal(!1) })])
	}),
	countryCode: e.string().length(2).toUpperCase(),
	centerOfCountry: e.strictObject({
		latitude: e.number(),
		longitude: e.number(),
		zoom: e.number()
	}),
	subscriptions: e.strictObject({
		bundle: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
			enabled: e.literal(!0),
			labelFeePrice: e.number().meta({
				description: "Label fee in cents, charged per shipment on top of the shipping rate.",
				example: 10
			}),
			shippingDiscount: e.number().meta({
				description: "Discount in cents subtracted from the shipping rate of every parcel shipment.",
				example: 35
			}),
			netDiscount: e.number().meta({
				description: "Saving per shipment in cents as advertised on the bundle cards. The pricing copy presents this as the shipping discount minus the label fee, so keep all three in step when changing any of them.",
				example: 25
			}),
			hasDiscountExclusions: e.boolean().meta({ description: "Whether some products are excluded from the shipping discount. Which products those are is part of the copy, not of this config: setting this appends the `subscriptions.bundles.footerExclusions` sentence to the pricing footer." })
		})]),
		myAnalytics: e.strictObject({
			enabled: e.boolean(),
			availableDashboards: e.array(e.string()),
			usps: e.strictObject({
				start: e.array(v).optional(),
				plus: e.array(v).optional(),
				premium: e.array(v).optional(),
				max: e.array(v).optional()
			}).describe("USPs to hide show tier. Each string matches the last segment of an i18n key under `myAnalytics.usps.*`.")
		}),
		myContracts: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(y).optional(),
				plus: e.array(y).optional(),
				premium: e.array(y).optional(),
				max: e.array(y).optional()
			}).optional().describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myContracts.usps.*`.")
		}),
		myOrders: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(b).optional(),
				plus: e.array(b).optional(),
				premium: e.array(b).optional(),
				max: e.array(b).optional()
			}).describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myOrders.usps.*`.")
		}),
		myScanAndPrint: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(ee).optional(),
				plus: e.array(ee).optional(),
				premium: e.array(ee).optional(),
				max: e.array(ee).optional()
			}).optional().describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myScanAndPrint.usps.*`.")
		}),
		myReturns: e.strictObject({
			enabled: e.boolean(),
			usps: e.strictObject({
				start: e.array(_).optional(),
				plus: e.array(_).optional(),
				premium: e.array(_).optional(),
				max: e.array(_).optional()
			}).optional().describe("USPs to show per tier. Each string matches the last segment of an i18n key under `myReturns.usps.*`.")
		}),
		orderRules: e.strictObject({ maxAmount: e.strictObject({
			default: e.number(),
			start: e.number(),
			plus: e.number()
		}) }),
		shippingRules: e.strictObject({
			countryCodes: e.array(e.string()),
			regionCodes: e.array(e.string()),
			maxAmount: e.number()
		}),
		showFooterText: e.boolean().optional().meta({ description: "Whether the pricing footer below the bundle cards is shown. Leaving this false suppresses the footer but not the asterisk on the cards that refers to it, so the marker is left without a note." })
	}),
	billing: e.strictObject({
		allowDisablingInvoiceEmails: e.boolean().describe("Whether the proposition allows shops to disable invoice emails from MyParcel. This does not indicate whether the feature is enabled for a shop, but whether it can be enabled or disabled."),
		sendsInvoiceEmailReminders: e.boolean().describe("Whether invoice reminders get sent trough email or the invoice itself."),
		paymentProvider: e.string(),
		ibanExample: e.string().meta({
			description: "An example IBAN in the proposition's own country format, shown as the placeholder of the bank account number field. Has the right length and layout for the country, but uses check digits of 00, which the mod-97 algorithm never produces, so it can never collide with a real account.",
			example: "NL00MYPA0123456789"
		}),
		bankMandate: e.strictObject({ cocRequired: e.boolean() }),
		vetting: e.strictObject({
			vatNumber: e.boolean(),
			routingNumber: e.boolean(),
			pecEmail: e.boolean()
		}),
		newInvoiceDates: e.strictObject({
			weekly: e.string(),
			monthly: e.string()
		}),
		invoiceFormats: e.array(e.enum([
			"CSV",
			"PDF",
			"UBL-XML"
		]))
	}),
	brackets: e.strictObject({
		weightTiers: e.partialRecord(c, e.array(e.strictObject({
			min: e.number().int(),
			max: e.number().int(),
			name: e.string()
		}))),
		availableForCarriers: e.array(c)
	}),
	collectTrip: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.discriminatedUnion("type", [e.strictObject({
		enabled: e.literal(!0),
		type: e.literal("internal")
	}), e.strictObject({
		enabled: e.literal(!0),
		type: e.literal("external"),
		url: e.url()
	})])]),
	contracts: e.strictObject({
		available: e.array(x.extend({
			hasCutoffTime: e.boolean(),
			hasPostponedDelivery: e.boolean(),
			inboundFeatures: te.optional(),
			outboundFeatures: te.optional(),
			surcharges: e.array(ne.optional()).optional()
		})),
		availableForCustomCredentials: e.array(x),
		enablePostNLCustomContract: e.boolean(),
		inbound: e.record(e.string(), x).and(e.object({ default: x })),
		outbound: e.record(e.string(), x).and(e.object({ default: x }))
	}),
	companyDetails: e.strictObject({
		billing: e.strictObject({
			coc: e.string(),
			vatNumber: e.string()
		}),
		contact: e.strictObject({
			phoneNumber: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
				enabled: e.literal(!0),
				plain: e.string(),
				text: e.string(),
				openingHours: e.array(e.strictObject({
					name: e.string(),
					opens: e.string().optional(),
					closes: e.string().optional()
				}))
			})]),
			whatsapp: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
				enabled: e.literal(!0),
				url: e.url(),
				openingHours: e.array(e.strictObject({
					name: e.string(),
					opens: e.string().optional(),
					closes: e.string().optional()
				}))
			})])
		}),
		returnAddress: e.strictObject({
			countryCode: e.string(),
			company: e.string(),
			person: e.string(),
			postalCode: e.string(),
			houseNumber: e.string(),
			street: e.string(),
			city: e.string(),
			phone: e.string(),
			email: e.email()
		}),
		address: e.strictObject({
			countryCode: e.string(),
			company: e.string(),
			person: e.string(),
			postalCode: e.string(),
			houseNumber: e.string(),
			street: e.string(),
			city: e.string(),
			phone: e.string(),
			email: e.email()
		})
	}),
	assets: e.strictObject({
		url: e.url(),
		logo: e.strictObject({
			medium: e.strictObject({ url: e.url() }),
			small: e.strictObject({ url: e.url() })
		}),
		exampleDocuments: e.strictObject({
			products: e.strictObject({ csv: e.url() }),
			orders: e.strictObject({ csv: e.url() }),
			ordersCsvImport: e.record(e.string(), e.strictObject({ csv: e.url() })),
			shipments: e.strictObject({ csv: e.url() }),
			addresses: e.record(e.string(), e.strictObject({ csv: e.url() }))
		})
	}),
	rules: e.strictObject({
		requiresEmailRecipient: e.boolean(),
		country: e.strictObject({
			withAddressFinder: e.array(e.string()),
			withPalletDelivery: e.array(e.string()),
			withPartnerLinks: e.array(e.string()),
			withPossibleReturn: e.array(e.string()),
			withRecommendedPhoneNumber: e.array(e.string()),
			withRequiredPhoneNumber: e.array(e.string()),
			withRequiredEmail: e.array(e.string()),
			withRequiredCompany: e.array(e.string()),
			withRequiredLabelDescription: e.array(e.string()),
			withRequiredHeight: e.array(e.string()),
			withRequiredLength: e.array(e.string()),
			withRequiredWidth: e.array(e.string()),
			withSeparatedStreetAndNumber: e.array(e.string())
		}),
		carrier: e.strictObject({
			withRecommendedPhoneNumber: e.array(e.string()),
			withRequiredPhoneNumber: e.array(e.string()),
			withRequiredEmail: e.array(e.string()),
			withRequiredCompany: e.array(e.string()),
			withRequiredLabelDescription: e.array(e.string()),
			withRequiredHeight: e.array(e.string()),
			withRequiredLength: e.array(e.string()),
			withRequiredWidth: e.array(e.string()),
			withRequiredWeight: e.array(e.string())
		})
	}),
	enableAcademy: e.boolean(),
	useToponymicAddressLabels: e.boolean().describe("Use toponymy-aware destination address labelling for each locale. For example: `Indirizzo di destinazione` instead of via e numero civico."),
	enablePrinterlessReturn: e.boolean(),
	enableLogoOnLabel: e.boolean(),
	enableShipmentEstimate: e.boolean(),
	enableCompanyDetailsEdit: e.boolean(),
	enableCompanyContactVatNumberNote: e.boolean(),
	enableContactChamberOfCommerce: e.boolean(),
	enableContactCompanyName: e.boolean(),
	enableContactVatNumber: e.boolean(),
	enableLocationFinder: e.boolean(),
	enableMyParcelAsReturnAddress: e.boolean(),
	enableFulfilment: e.boolean(),
	enableSalesChannels: e.boolean(),
	availableSalesChannels: e.array(l),
	enableRetailLocations: e.boolean(),
	enableOptionToHideMyParcelLogo: e.boolean(),
	enableTellAFriend: e.boolean(),
	enableReturnContributions: e.array(u),
	enableLabelPackages: e.boolean(),
	enableEmailCenter: e.boolean(),
	notifications: e.strictObject({ emails: e.strictObject({ enableInternational: e.boolean() }) }),
	enableRatesOverview: e.boolean(),
	support: e.strictObject({
		flow: e.union([e.literal("basic"), e.literal("advanced")]),
		availableTypes: e.array(e.strictObject({
			name: e.string(),
			id: e.number().int(),
			subTypes: e.array(e.string()).optional(),
			extraField: e.strictObject({
				name: e.string(),
				optional: e.boolean()
			}).optional()
		}))
	}),
	integrations: e.strictObject({ available: e.array(e.strictObject({
		id: e.number().int(),
		name: e.string(),
		hasAutoImport: e.boolean(),
		manualUrl: e.url().optional(),
		configurationParameters: e.array(e.strictObject({
			name: e.string(),
			human: e.string()
		})).optional()
	})) }),
	content: e.record(e.string(), ie),
	weightCategories: e.record(e.string(), e.array(e.strictObject({
		median: e.number(),
		min: e.number(),
		max: e.number()
	}))),
	tools: e.strictObject({
		salesforce: e.strictObject({ enabled: e.boolean() }),
		googleTagManager: e.strictObject({
			enabled: e.boolean(),
			id: e.string(),
			url: e.url().or(e.literal(""))
		}),
		appcues: e.strictObject({
			enabled: e.boolean(),
			id: e.string(),
			enableLaunchpad: e.boolean()
		}),
		cookieConsent: e.strictObject({
			type: e.union([e.literal("cookiebot"), e.literal("oneTrust")]),
			enabled: e.boolean(),
			id: e.string()
		}),
		hotjar: e.strictObject({
			enabled: e.boolean(),
			id: e.string(),
			enableFeedbackModal: e.boolean()
		})
	}),
	browserExtension: e.discriminatedUnion("enabled", [e.strictObject({ enabled: e.literal(!1) }), e.strictObject({
		enabled: e.literal(!0),
		downloadUrl: e.strictObject({ chrome: e.url() })
	})]),
	deliveryOptions: e.strictObject({
		mondayDelivery: e.boolean(),
		dropOffDays: e.array(e.number().int())
	}),
	settings: e.strictObject({
		companyContact: e.strictObject({
			additionalProperties: e.array(e.string()),
			requiredProperties: e.array(e.string())
		}),
		export: e.strictObject({ availableProperties: e.array(e.union([
			e.literal("eori"),
			e.literal("voec"),
			e.literal("vatUk")
		])) }),
		enableIntegrations: e.boolean(),
		rules: e.strictObject({
			enableOrderRules: e.boolean(),
			enableReturnRules: e.boolean(),
			enableShipmentRules: e.boolean()
		}),
		shop: e.strictObject({ enableReturns: e.boolean() })
	}),
	orders: e.strictObject({ filters: e.strictObject({
		carriers: e.array(c),
		packageTypes: e.array(u),
		regionCodes: e.array(e.string())
	}) }),
	shipments: e.strictObject({
		hasShipmentsOverview: e.boolean().describe("Whether the proposition has a shipments overview page"),
		hasPriorityDelivery: e.boolean().meta({ description: "Whether the proposition supports PostNL priority delivery (24h)" }),
		enableInternational: e.boolean().describe("Whether the proposition allows for international shipments"),
		enableCsvImport: e.boolean(),
		enablePallet: e.boolean(),
		enableReturn: e.boolean(),
		enableGoodsImportExport: e.boolean(),
		enableSocialShipping: e.boolean(),
		filters: e.strictObject({
			packageTypes: e.array(u).meta({ description: "All package types that a user can select to filter shipments on the overview page." }),
			regionCodes: e.array(d).meta({ description: "All region codes that a user can select to filter shipments on the overview page." })
		}).meta({ description: "Filters configuration for on the shipments overview page. This is used to determine which filters are available for the user to select." })
	}),
	rates: e.strictObject({ subjects: e.array(oe) })
}), ce = (e) => e === "acceptance" ? "acceptance" : "production", le = async (e, t = "production") => {
	let n = ce(t), r;
	switch (e) {
		case "myparcel-nederland":
			r = (await import("./configs/myparcel-nederland.js")).default;
			break;
		case "myparcel-belgie":
			r = (await import("./configs/myparcel-belgie.js")).default;
			break;
		case "myparcel-italie":
		case "myparcel-com":
			r = (await import("./configs/myparcel-italie.js")).default;
			break;
		default: throw Error(`Unknown proposition key: ${String(e)}`);
	}
	return r(n);
}, ue = Object.create, de = Object.defineProperty, fe = Object.getOwnPropertyDescriptor, pe = Object.getOwnPropertyNames, me = Object.getPrototypeOf, he = Object.prototype.hasOwnProperty, C = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), ge = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = pe(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !he.call(e, s) && s !== n && de(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = fe(t, s)) || r.enumerable
	});
	return e;
}, w = (e, t, n) => (n = e == null ? {} : ue(me(e)), ge(t || !e || !e.__esModule || !he.call(e, "default") ? de(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), T = {
	PostNl: 1,
	Bpost: 2,
	CheapCargo: 3,
	Dpd: 4,
	Instabox: 5,
	Dhl: 6,
	Bol: 7,
	Ups: 8,
	DhlForYou: 9,
	DhlParcelConnect: 10,
	DhlEuroPlus: 11,
	UpsStandard: 12,
	UpsExpressSaver: 13,
	Gls: 14,
	Brt: 15,
	Trunkrs: 16,
	InPost: 17,
	PosteItaliane: 18,
	Spring: 19,
	ViaTim: 20,
	DhlFreight: 21
}, E = {
	PostNl: "postnl",
	POSTNL: "POSTNL",
	Bpost: "bpost",
	BPOST: "BPOST",
	CheapCargo: "cheapcargo",
	CHEAP_CARGO: "CHEAP_CARGO",
	Dpd: "dpd",
	DPD: "DPD",
	Instabox: "instabox",
	INSTABOX: "INSTABOX",
	Dhl: "dhl",
	BolCom: "bol.com",
	Bol: "bol",
	BOL: "BOL",
	Ups: "ups",
	UPS: "ups",
	DHL: "DHL",
	DhlForYou: "dhlforyou",
	DHL_FOR_YOU: "DHL_FOR_YOU",
	DhlParcelConnect: "dhlparcelconnect",
	DHL_PARCEL_CONNECT: "DHL_PARCEL_CONNECT",
	DhlEuroPlus: "dhleuroplus",
	DHL_EUROPLUS: "DHL_EUROPLUS",
	UpsStandard: "upsstandard",
	UPS_STANDARD: "UPS_STANDARD",
	UpsExpressSaver: "upsexpresssaver",
	UPS_EXPRESS_SAVER: "UPS_EXPRESS_SAVER",
	Gls: "gls",
	GLS: "GLS",
	Brt: "brt",
	BRT: "BRT",
	Trunkrs: "trunkrs",
	TRUNKRS: "TRUNKRS",
	InPost: "inpost",
	INPOST: "INPOST",
	PosteItaliane: "posteitaliane",
	POSTE_ITALIANE: "POSTE_ITALIANE",
	Spring: "spring",
	SPRING: "SPRING",
	ViaTim: "viatim",
	VIA_TIM: "VIA_TIM",
	DhlFreight: "dhlfreight",
	DHL_FREIGHT: "DHL_FREIGHT"
};
T.Dhl, T.Instabox, T.PostNl, E.PostNl, T.Bpost, E.Bpost, T.CheapCargo, E.CheapCargo, T.Dpd, E.Dpd, T.Instabox, E.Instabox, T.Dhl, E.Dhl, T.Bol, E.Bol, T.Ups, E.Ups, T.DhlForYou, E.DhlForYou, T.DhlParcelConnect, E.DhlParcelConnect, T.DhlEuroPlus, E.DhlEuroPlus, T.UpsStandard, E.UpsStandard, T.UpsExpressSaver, E.UpsExpressSaver, T.Gls, E.Gls, T.Brt, E.Brt, T.Trunkrs, E.Trunkrs, T.InPost, E.InPost, T.PosteItaliane, E.PosteItaliane, T.Spring, E.Spring, T.ViaTim, E.ViaTim, T.DhlFreight, E.DhlFreight, T.PostNl, E.POSTNL, T.Bpost, E.BPOST, T.CheapCargo, E.CHEAP_CARGO, T.Dpd, E.DPD, T.Instabox, E.INSTABOX, T.Dhl, E.DHL, T.Bol, E.BOL, T.Ups, E.UPS, T.DhlForYou, E.DHL_FOR_YOU, T.DhlParcelConnect, E.DHL_PARCEL_CONNECT, T.DhlEuroPlus, E.DHL_EUROPLUS, T.UpsStandard, E.UPS_STANDARD, T.UpsExpressSaver, E.UPS_EXPRESS_SAVER, T.Gls, E.GLS, T.Brt, E.BRT, T.Trunkrs, E.TRUNKRS, T.InPost, E.INPOST, T.PosteItaliane, E.POSTE_ITALIANE, T.Spring, E.SPRING, T.ViaTim, E.VIA_TIM, T.DhlFreight, E.DHL_FREIGHT, E.POSTNL, T.PostNl, E.BPOST, T.Bpost, E.CHEAP_CARGO, T.CheapCargo, E.DPD, T.Dpd, E.INSTABOX, T.Instabox, E.DHL, T.Dhl, E.BOL, T.Bol, E.UPS, T.Ups, E.DHL_FOR_YOU, T.DhlForYou, E.DHL_PARCEL_CONNECT, T.DhlParcelConnect, E.DHL_EUROPLUS, T.DhlEuroPlus, E.UPS_STANDARD, T.UpsStandard, E.UPS_EXPRESS_SAVER, T.UpsExpressSaver, E.GLS, T.Gls, E.BRT, T.Brt, E.TRUNKRS, T.Trunkrs, E.INPOST, T.InPost, E.POSTE_ITALIANE, T.PosteItaliane, E.SPRING, T.Spring, E.VIA_TIM, T.ViaTim, E.DHL_FREIGHT, T.DhlFreight, E.PostNl, T.PostNl, E.POSTNL, T.PostNl, E.Bpost, T.Bpost, E.BPOST, T.Bpost, E.CheapCargo, T.CheapCargo, E.CHEAP_CARGO, T.CheapCargo, E.Dpd, T.Dpd, E.DPD, T.Dpd, E.Instabox, T.Instabox, E.Dhl, T.Dhl, E.BolCom, T.Bol, E.Bol, T.Bol, E.BOL, T.Bol, E.Ups, T.Ups, E.DhlForYou, T.DhlForYou, E.DHL_FOR_YOU, T.DhlForYou, E.DhlParcelConnect, T.DhlParcelConnect, E.DHL_PARCEL_CONNECT, T.DhlParcelConnect, E.DhlEuroPlus, T.DhlEuroPlus, E.DHL_EUROPLUS, T.DhlEuroPlus, E.UpsStandard, T.UpsStandard, E.UPS_STANDARD, T.UpsStandard, E.UpsExpressSaver, T.UpsExpressSaver, E.UPS_EXPRESS_SAVER, T.UpsExpressSaver, E.Gls, T.Gls, E.GLS, T.Gls, E.Brt, T.Brt, E.BRT, T.Brt, E.Trunkrs, T.Trunkrs, E.TRUNKRS, T.Trunkrs, E.InPost, T.InPost, E.INPOST, T.InPost, E.PosteItaliane, T.PosteItaliane, E.POSTE_ITALIANE, T.PosteItaliane, E.Spring, T.Spring, E.SPRING, T.Spring, E.ViaTim, T.ViaTim, E.VIA_TIM, T.ViaTim, E.DhlFreight, T.DhlFreight, E.DHL_FREIGHT, T.DhlFreight, T.PostNl, T.Bpost, T.CheapCargo, T.Dpd, T.Instabox, T.Dhl, T.Bol, T.Ups, T.DhlForYou, T.DhlParcelConnect, T.DhlEuroPlus, T.UpsStandard, T.UpsExpressSaver, T.Gls, T.Brt, T.Trunkrs, T.InPost, T.PosteItaliane, T.Spring, T.ViaTim, T.DhlFreight;
var D = {
	Afghanistan: "AF",
	AlandIslands: "AX",
	Albania: "AL",
	Algeria: "DZ",
	AmericanSamoa: "AS",
	AmericanVirginIslands: "VI",
	Andorra: "AD",
	Angola: "AO",
	Anguilla: "AI",
	Antarctica: "AQ",
	AntiguaAndBarbuda: "AG",
	Argentina: "AR",
	Armenia: "AM",
	Aruba: "AW",
	Australia: "AU",
	Austria: "AT",
	Azerbaijan: "AZ",
	Bahamas: "BS",
	Bahrain: "BH",
	Bangladesh: "BD",
	Barbados: "BB",
	Belarus: "BY",
	Belgium: "BE",
	Belize: "BZ",
	Benin: "BJ",
	Bermuda: "BM",
	Bhutan: "BT",
	Bolivia: "BO",
	BonaireSintEustatiusAndSaba: "BQ",
	BosniaAndHerzegovina: "BA",
	Botswana: "BW",
	BouvetIsland: "BV",
	Brazil: "BR",
	BritishIndianOceanTerritory: "IO",
	BritishVirginIslands: "VG",
	BruneiDarussalam: "BN",
	Bulgaria: "BG",
	BurkinaFaso: "BF",
	Burundi: "BI",
	CaboVerde: "CV",
	Cambodia: "KH",
	Cameroon: "CM",
	Canada: "CA",
	CanaryIslands: "IC",
	CaymanIslands: "KY",
	CentralAfricanRepublic: "CF",
	Chad: "TD",
	Chile: "CL",
	China: "CN",
	ChristmasIsland: "CX",
	CocosIslands: "CC",
	Colombia: "CO",
	Comoros: "KM",
	CongoBrazzaville: "CG",
	CongoKinshasa: "CD",
	CookIslands: "CK",
	CostaRica: "CR",
	CoteDIvoire: "CI",
	Croatia: "HR",
	Cuba: "CU",
	Curacao: "CW",
	Cyprus: "CY",
	CzechRepublic: "CZ",
	Denmark: "DK",
	Djibouti: "DJ",
	Dominica: "DM",
	DominicanRepublic: "DO",
	DutchAntilles: "AN",
	Ecuador: "EC",
	Egypt: "EG",
	ElSalvador: "SV",
	EquatorialGuinea: "GQ",
	Eritrea: "ER",
	Estonia: "EE",
	Eswatini: "SZ",
	Ethiopia: "ET",
	FalklandIslands: "FK",
	FaroeIslands: "FO",
	Fiji: "FJ",
	Finland: "FI",
	France: "FR",
	FrenchGuiana: "GF",
	FrenchPolynesia: "PF",
	FrenchSouthernTerritories: "TF",
	Gabon: "GA",
	Gambia: "GM",
	Georgia: "GE",
	Germany: "DE",
	Ghana: "GH",
	Gibraltar: "GI",
	Greece: "GR",
	Greenland: "GL",
	Grenada: "GD",
	Guadeloupe: "GP",
	Guam: "GU",
	Guatemala: "GT",
	Guernsey: "GG",
	Guinea: "GN",
	GuineaBissau: "GW",
	Guyana: "GY",
	Haiti: "HT",
	HeardIslandAndMcdonaldIslands: "HM",
	HolySee: "VA",
	Honduras: "HN",
	HongKong: "HK",
	Hungary: "HU",
	Iceland: "IS",
	India: "IN",
	Indonesia: "ID",
	Iran: "IR",
	Iraq: "IQ",
	Ireland: "IE",
	IsleOfMan: "IM",
	Israel: "IL",
	Italy: "IT",
	Jamaica: "JM",
	Japan: "JP",
	Jersey: "JE",
	Jordan: "JO",
	Kazakhstan: "KZ",
	Kenya: "KE",
	Kiribati: "KI",
	KoreaPeoplesDemocraticRepublic: "KP",
	KoreaRepublic: "KR",
	Kosovo: "XK",
	Kuwait: "KW",
	Kyrgyzstan: "KG",
	Laos: "LA",
	Latvia: "LV",
	Lebanon: "LB",
	Lesotho: "LS",
	Liberia: "LR",
	Libya: "LY",
	Liechtenstein: "LI",
	Lithuania: "LT",
	Luxembourg: "LU",
	Macao: "MO",
	Madagascar: "MG",
	Malawi: "MW",
	Malaysia: "MY",
	Maldives: "MV",
	Mali: "ML",
	Malta: "MT",
	MarshallIslands: "MH",
	Martinique: "MQ",
	Mauritania: "MR",
	Mauritius: "MU",
	Mayotte: "YT",
	Mexico: "MX",
	Micronesia: "FM",
	Moldova: "MD",
	Monaco: "MC",
	Mongolia: "MN",
	Montenegro: "ME",
	Montserrat: "MS",
	Morocco: "MA",
	Mozambique: "MZ",
	Myanmar: "MM",
	Namibia: "NA",
	Nauru: "NR",
	Nepal: "NP",
	Netherlands: "NL",
	NewCaledonia: "NC",
	NewZealand: "NZ",
	Nicaragua: "NI",
	Niger: "NE",
	Nigeria: "NG",
	Niue: "NU",
	NorfolkIsland: "NF",
	NorthMacedonia: "MK",
	NorthernMarianaIslands: "MP",
	Norway: "NO",
	Oman: "OM",
	Pakistan: "PK",
	Palau: "PW",
	Palestine: "PS",
	Panama: "PA",
	PapuaNewGuinea: "PG",
	Paraguay: "PY",
	Peru: "PE",
	Philippines: "PH",
	Pitcairn: "PN",
	Poland: "PL",
	Portugal: "PT",
	PuertoRico: "PR",
	Qatar: "QA",
	Reunion: "RE",
	Romania: "RO",
	RussianFederation: "RU",
	Rwanda: "RW",
	SaintBarthelemy: "BL",
	SaintHelena: "SH",
	SaintKittsAndNevis: "KN",
	SaintLucia: "LC",
	SaintMartin: "MF",
	SaintPierreAndMiquelon: "PM",
	SaintVincentAndTheGrenadines: "VC",
	Samoa: "WS",
	SanMarino: "SM",
	SaoTomeAndPrincipe: "ST",
	SaudiArabia: "SA",
	Senegal: "SN",
	Serbia: "RS",
	Seychelles: "SC",
	SierraLeone: "SL",
	Singapore: "SG",
	SintMaarten: "SX",
	Slovakia: "SK",
	Slovenia: "SI",
	SolomonIslands: "SB",
	Somalia: "SO",
	SouthAfrica: "ZA",
	SouthGeorgiaAndTheSouthSandwichIslands: "GS",
	SouthSudan: "SS",
	Spain: "ES",
	SriLanka: "LK",
	Sudan: "SD",
	Suriname: "SR",
	SvalbardAndJanMayen: "SJ",
	Sweden: "SE",
	Switzerland: "CH",
	SyrianArabRepublic: "SY",
	Taiwan: "TW",
	Tajikistan: "TJ",
	Tanzania: "TZ",
	Thailand: "TH",
	TimorLeste: "TL",
	Togo: "TG",
	Tokelau: "TK",
	Tonga: "TO",
	TrinidadAndTobago: "TT",
	Tunisia: "TN",
	Turkey: "TR",
	Turkmenistan: "TM",
	TurksAndCaicosIslands: "TC",
	Tuvalu: "TV",
	Uganda: "UG",
	Ukraine: "UA",
	UnitedArabEmirates: "AE",
	UnitedKingdom: "GB",
	UnitedStatesMinorOutlyingIslands: "UM",
	UnitedStatesOfAmerica: "US",
	Uruguay: "UY",
	Uzbekistan: "UZ",
	Vanuatu: "VU",
	Venezuela: "VE",
	Vietnam: "VN",
	WallisAndFutuna: "WF",
	WesternSahara: "EH",
	Yemen: "YE",
	Zambia: "ZM",
	Zimbabwe: "ZW"
};
D.Austria, D.Belgium, D.Bulgaria, D.Croatia, D.Cyprus, D.CzechRepublic, D.Denmark, D.Estonia, D.Finland, D.France, D.Germany, D.Greece, D.Hungary, D.Ireland, D.Italy, D.Latvia, D.Lithuania, D.Luxembourg, D.Malta, D.Netherlands, D.Poland, D.Portugal, D.Romania, D.Slovakia, D.Slovenia, D.Spain, D.Sweden, Object.values(D), D.Angola, D.AntiguaAndBarbuda, D.Aruba, D.Bahamas, D.Belize, D.Benin, D.Bermuda, D.BonaireSintEustatiusAndSaba, D.Botswana, D.BurkinaFaso, D.Burundi, D.Cameroon, D.CanaryIslands, D.CentralAfricanRepublic, D.Comoros, D.CongoBrazzaville, D.CongoKinshasa, D.CoteDIvoire, D.Curacao, D.Djibouti, D.Dominica, D.DutchAntilles, D.EquatorialGuinea, D.Eritrea, D.Fiji, D.Gabon, D.Gambia, D.Ghana, D.Grenada, D.Guyana, D.HongKong, D.Kiribati, D.KoreaPeoplesDemocraticRepublic, D.Macao, D.Malawi, D.Mali, D.Mauritania, D.Nauru, D.Qatar, D.Rwanda, D.SaintKittsAndNevis, D.SaoTomeAndPrincipe, D.Seychelles, D.SierraLeone, D.SintMaarten, D.Suriname, D.SyrianArabRepublic, D.TimorLeste, D.Togo, D.Tonga, D.Tuvalu, D.Uganda, D.UnitedArabEmirates, D.Vanuatu, D.Yemen, D.Zimbabwe, D.Austria, D.Belgium, D.Bulgaria, D.Croatia, D.CzechRepublic, D.Estonia, D.Finland, D.France, D.Germany, D.Greece, D.Hungary, D.Ireland, D.Italy, D.Latvia, D.Lithuania, D.Luxembourg, D.Malta, D.Netherlands, D.Portugal, D.Romania, D.Slovakia, D.Slovenia, D.Spain, D.UnitedKingdom, D.Denmark, D.Germany, D.Sweden;
var O = {
	EarlyMorning: 8,
	Morning: 1,
	Standard: 2,
	Evening: 3,
	Pickup: 4,
	PickupExpress: 5,
	SameDayDelivery: 6,
	Express: 7
}, k = {
	EarlyMorning: "early_morning",
	Morning: "morning",
	Standard: "standard",
	Evening: "evening",
	Pickup: "pickup",
	PickupExpress: "pickup_express",
	SameDayDelivery: "same_day",
	Express: "express"
}, A = {
	EarlyMorning: "EARLY_MORNING_DELIVERY",
	Morning: "MORNING_DELIVERY",
	Standard: "STANDARD_DELIVERY",
	Evening: "EVENING_DELIVERY",
	Pickup: "PICKUP_DELIVERY",
	PickupExpress: "PICKUP_EXPRESS_DELIVERY",
	SameDayDelivery: "SAME_DAY_DELIVERY",
	Express: "EXPRESS_DELIVERY"
};
O.EarlyMorning, k.EarlyMorning, O.Morning, k.Morning, O.Standard, k.Standard, O.Evening, k.Evening, O.Pickup, k.Pickup, O.PickupExpress, k.PickupExpress, O.SameDayDelivery, k.SameDayDelivery, O.Express, k.Express, k.EarlyMorning, O.EarlyMorning, k.Morning, O.Morning, k.Standard, O.Standard, k.Evening, O.Evening, k.Pickup, O.Pickup, k.PickupExpress, O.PickupExpress, k.SameDayDelivery, O.SameDayDelivery, k.Express, O.Express, O.EarlyMorning, A.EarlyMorning, O.Morning, A.Morning, O.Standard, A.Standard, O.Evening, A.Evening, O.Pickup, A.Pickup, O.PickupExpress, A.PickupExpress, O.SameDayDelivery, A.SameDayDelivery, O.Express, A.Express, A.EarlyMorning, k.EarlyMorning, A.Morning, k.Morning, A.Standard, k.Standard, A.Evening, k.Evening, A.Pickup, k.Pickup, A.PickupExpress, k.PickupExpress, A.SameDayDelivery, k.SameDayDelivery, A.Express, k.Express, O.EarlyMorning, O.Morning, O.Standard, O.Evening, O.Pickup, O.PickupExpress, O.SameDayDelivery, O.Express, { Vasco: 1 }.Vasco, { Vasco: "vasco" }.Vasco;
var j = {
	Sunday: 0,
	Monday: 1,
	Tuesday: 2,
	Wednesday: 3,
	Thursday: 4,
	Friday: 5,
	Saturday: 6
}, M = {
	Sunday: "sunday",
	Monday: "monday",
	Tuesday: "tuesday",
	Wednesday: "wednesday",
	Thursday: "thursday",
	Friday: "friday",
	Saturday: "saturday"
};
M.Sunday, j.Sunday, M.Monday, j.Monday, M.Tuesday, j.Tuesday, M.Wednesday, j.Wednesday, M.Thursday, j.Thursday, M.Friday, j.Friday, M.Saturday, j.Saturday, j.Sunday, M.Sunday, j.Monday, M.Monday, j.Tuesday, M.Tuesday, j.Wednesday, M.Wednesday, j.Thursday, M.Thursday, j.Friday, M.Friday, j.Saturday, M.Saturday;
var _e = {
	Bytes: "B",
	Kilobytes: "KB",
	Megabytes: "MB",
	Gigabytes: "GB",
	Terabytes: "TB"
};
_e.Bytes, _e.Kilobytes, _e.Megabytes, _e.Gigabytes, _e.Terabytes;
var N = {
	Bol: 1,
	Exact: 2,
	Amazon: 6,
	Wix: 8,
	ExactDe: 10,
	Etsy: 11
}, P = {
	Bol: "bol_dot_com",
	Wix: "wix",
	Exact: "exact",
	ExactDe: "exact_de",
	Amazon: "amazon",
	Etsy: "etsy"
};
N.Bol, P.Bol, N.Exact, P.Exact, N.Amazon, P.Amazon, N.Wix, P.Wix, N.ExactDe, P.ExactDe, N.Etsy, P.Etsy, P.Bol, N.Bol, P.Exact, N.Exact, P.Amazon, N.Amazon, P.Wix, N.Wix, P.ExactDe, N.ExactDe, P.Etsy, N.Etsy;
var F = {
	Unpaid: 1,
	Due: 101,
	DuePrepayment: 102,
	Reminder1: 106,
	Reminder2: 111,
	Dun: 116,
	Collection: 121,
	Instalments: 126,
	PaymentArrangement: 127,
	Dispute: 128,
	LegalProcedure: 129,
	Insolvency: 130,
	WriteOff: 131,
	Pending: 301,
	Cancelled: 401,
	Paid: 501,
	PaidOnline: 506,
	PaidAutomatic: 511,
	PaidCredit: 597,
	PaidZeroItems: 598,
	InvoiceWith0InvoiceItemsPaidZeroBalance: 599
}, I = {
	Unpaid: "Unpaid",
	Due: "Due",
	DuePrepayment: "DuePrepayment",
	Reminder1: "Reminder1",
	Reminder2: "Reminder2",
	Dun: "Dun",
	Collection: "Collection",
	Instalments: "Instalments",
	PaymentArrangement: "PaymentArrangement",
	Dispute: "Dispute",
	LegalProcedure: "LegalProcedure",
	Insolvency: "Insolvency",
	WriteOff: "WriteOff",
	Pending: "Pending",
	Cancelled: "Cancelled",
	Paid: "Paid",
	PaidOnline: "PaidOnline",
	PaidAutomatic: "PaidAutomatic",
	PaidCredit: "PaidCredit",
	PaidZeroItems: "PaidZeroItems",
	PaidZeroBalance: "PaidZeroBalance"
};
F.Unpaid, I.Unpaid, F.Due, I.Due, F.DuePrepayment, I.DuePrepayment, F.Reminder1, I.Reminder1, F.Reminder2, I.Reminder2, F.Dun, I.Dun, F.Collection, I.Collection, F.Instalments, I.Instalments, F.PaymentArrangement, I.PaymentArrangement, F.Dispute, I.Dispute, F.LegalProcedure, I.LegalProcedure, F.Insolvency, I.Insolvency, F.WriteOff, I.WriteOff, F.Pending, I.Pending, F.Cancelled, I.Cancelled, F.Paid, I.Paid, F.PaidOnline, I.PaidOnline, F.PaidAutomatic, I.PaidAutomatic, F.PaidCredit, I.PaidCredit, F.PaidZeroItems, I.PaidZeroItems, F.InvoiceWith0InvoiceItemsPaidZeroBalance, I.PaidZeroBalance, F.Due, F.Reminder1, F.Reminder2, F.Dun, F.Collection, F.Instalments, F.PaymentArrangement, F.Dispute, F.Paid, F.PaidOnline, F.PaidAutomatic, F.PaidCredit, F.PaidZeroItems;
var ve = {
	Gram: "g",
	Kilogram: "kg"
};
ve.Gram, ve.Kilogram;
var ye = {
	Millimeter: "mm",
	Centimeter: "cm",
	Meter: "m"
};
ye.Millimeter, ye.Centimeter, ye.Meter;
var L = {
	Eu: "EU",
	HomeCountry: "Home Country",
	Row: "ROW",
	Cd: "CD",
	World: "WERELD"
}, R = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnRouteHandedToCarrier: 3,
	EnRouteSorting: 4,
	EnRouteDistribution: 5,
	EnRouteCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedLetter: 12,
	InactiveCredited: 13,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnRouteHandedToCarrier: 32,
	InactiveEnRouteSorting: 33,
	InactiveEnRouteDistribution: 34,
	InactiveEnRouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38
};
R.PendingConcept, R.PendingRegistered, R.EnRouteHandedToCarrier, R.EnRouteSorting, R.EnRouteDistribution, R.EnRouteCustoms, R.DeliveredReadyForPickup, R.DeliveredAtRecipient, R.DeliveredPackagePickedUp;
var z = {
	Light: "light",
	Start: "start",
	Plus: "plus",
	Premium: "premium",
	Max: "max"
}, B = {
	Light: 0,
	Start: 1,
	Plus: 2,
	Premium: 3,
	Max: 4
};
B.Light, z.Light, B.Start, z.Start, B.Plus, z.Plus, B.Premium, z.Premium, B.Max, z.Max, z.Light, B.Light, z.Start, B.Start, z.Plus, B.Plus, z.Premium, B.Premium, z.Max, B.Max;
var V = {
	Start: 4800,
	Plus: 4801,
	Premium: 4802,
	Max: 4803
}, H = {
	Start: z.Start,
	Plus: z.Plus,
	Premium: z.Premium,
	Max: z.Max
};
V.Start, H.Start, V.Plus, H.Plus, V.Premium, H.Premium, V.Max, H.Max, H.Start, V.Start, H.Plus, V.Plus, H.Premium, V.Premium, H.Max, V.Max;
var be = {
	Start: 4700,
	Plus: 4701,
	Premium: 4702,
	Max: 4703
}, xe = {
	Start: z.Start,
	Plus: z.Plus,
	Premium: z.Premium,
	Max: z.Max
};
be.Start, xe.Start, be.Plus, xe.Plus, be.Premium, xe.Premium, be.Max, xe.Max, xe.Start, be.Start, xe.Plus, be.Plus, xe.Premium, be.Premium, xe.Max, be.Max;
var U = {
	Light: 4610,
	Start: 4611,
	Plus: 4612,
	Premium: 4613,
	Max: 4614
}, W = {
	Light: z.Light,
	Start: z.Start,
	Plus: z.Plus,
	Premium: z.Premium,
	Max: z.Max
};
U.Light, W.Light, U.Start, W.Start, U.Plus, W.Plus, U.Premium, W.Premium, U.Max, W.Max, W.Light, U.Light, W.Start, U.Start, W.Plus, U.Plus, W.Premium, U.Premium, W.Max, U.Max;
var G = {
	Start: 4615,
	Plus: 4616,
	Premium: 4617,
	Max: 4618
}, Se = {
	Start: z.Start,
	Plus: z.Plus,
	Premium: z.Premium,
	Max: z.Max
};
G.Start, Se.Start, G.Plus, Se.Plus, G.Premium, Se.Premium, G.Max, Se.Max, Se.Start, G.Start, Se.Plus, G.Plus, Se.Premium, G.Premium, Se.Max, G.Max;
var K = {
	MyParcel: 1,
	Flespakket: 2,
	SendMyParcel: 3,
	DeliverDutch: 4,
	PostNlPlugin: 5,
	MyParcelIt: 6
}, Ce = {
	MyParcel: "myparcel",
	Flespakket: "flespakket",
	SendMyParcel: "belgie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin",
	MyParcelIt: "italie"
}, q = {
	Default: "default",
	MyParcelNl: "myparcel-nederland",
	MyParcelBe: "myparcel-belgie",
	MyParcelIt: "myparcel-italie",
	DeliverDutch: "deliver-dutch",
	PostNlPlugin: "postnl-plugin"
};
K.MyParcel, Ce.MyParcel, K.Flespakket, Ce.Flespakket, K.SendMyParcel, Ce.SendMyParcel, K.MyParcelIt, Ce.MyParcelIt, K.DeliverDutch, Ce.DeliverDutch, K.PostNlPlugin, Ce.PostNlPlugin, K.MyParcel, q.MyParcelNl, K.Flespakket, q.MyParcelNl, K.SendMyParcel, q.MyParcelBe, K.MyParcelIt, q.MyParcelIt, K.DeliverDutch, q.DeliverDutch, K.PostNlPlugin, q.PostNlPlugin, q.MyParcelNl, K.MyParcel, q.MyParcelBe, K.SendMyParcel, q.MyParcelIt, K.MyParcelIt, q.MyParcelNl, L.HomeCountry, D.Netherlands, L.Eu, L.Row, D.Belgium, q.MyParcelBe, L.HomeCountry, D.Belgium, D.Netherlands, L.Eu, L.Row, q.MyParcelBe, L.HomeCountry, D.Belgium, L.Eu, L.Row, q.MyParcelNl, L.HomeCountry, D.Netherlands, L.Eu, L.Row, q.MyParcelNl, L.HomeCountry, D.Netherlands, D.Belgium, D.Luxembourg, T.Bpost, T.PostNl, T.DhlForYou, T.DhlParcelConnect, T.DhlEuroPlus, T.Ups, T.UpsStandard, T.UpsExpressSaver;
var J = {
	Package: 1,
	Mailbox: 2,
	Letter: 3,
	DigitalStamp: 4,
	Pallet: 5,
	PackageSmall: 6,
	Envelope: 7
}, Y = {
	Package: "package",
	Mailbox: "mailbox",
	Letter: "letter",
	DigitalStamp: "digital_stamp",
	Pallet: "pallet",
	PackageSmall: "package_small",
	Envelope: "envelope"
};
J.Package, Y.Package, J.Mailbox, Y.Mailbox, J.Letter, Y.Letter, J.DigitalStamp, Y.DigitalStamp, J.Pallet, Y.Pallet, J.PackageSmall, Y.PackageSmall, J.Envelope, Y.Envelope, Y.Package, J.Package, Y.Mailbox, J.Mailbox, Y.Letter, J.Letter, Y.DigitalStamp, J.DigitalStamp, Y.Pallet, J.Pallet, Y.PackageSmall, J.PackageSmall, Y.Envelope, J.Envelope;
var X = {
	DIGITAL_STAMP: "DIGITAL_STAMP",
	ENVELOPE: "ENVELOPE",
	MAILBOX: "MAILBOX",
	PACKAGE: "PACKAGE",
	PALLET: "PALLET",
	SMALL_PACKAGE: "SMALL_PACKAGE",
	UNFRANKED: "UNFRANKED"
};
J.Package, X.PACKAGE, J.Mailbox, X.MAILBOX, J.Letter, X.UNFRANKED, J.DigitalStamp, X.DIGITAL_STAMP, J.Pallet, X.PALLET, J.PackageSmall, X.SMALL_PACKAGE, J.Envelope, X.ENVELOPE, X.PACKAGE, J.Package, X.MAILBOX, J.Mailbox, X.UNFRANKED, J.Letter, X.DIGITAL_STAMP, J.DigitalStamp, X.PALLET, J.Pallet, X.SMALL_PACKAGE, J.PackageSmall, X.ENVELOPE, J.Envelope, J.Package, J.Mailbox, J.Letter, J.DigitalStamp, J.Pallet, J.PackageSmall, J.Envelope;
var Z = {
	PendingConcept: 1,
	PendingRegistered: 2,
	EnrouteHandedToCarrier: 3,
	EnrouteSorting: 4,
	EnrouteDistribution: 5,
	DeliveredAtCustoms: 6,
	DeliveredAtRecipient: 7,
	DeliveredReadyForPickup: 8,
	DeliveredPackagePickedUp: 9,
	DeliveredReturnShipmentReadyForPickup: 10,
	DeliveredReturnShipmentPackagePickedUp: 11,
	PrintedUnpaidLabel: 12,
	PrintedLetter: 12,
	Credited: 13,
	PrintedStamp: 14,
	PrintedDigitalStamp: 14,
	Expired: 16,
	Cancelled: 17,
	PrintedUntrackedShipment: 18,
	DeliveredAtAgreedLocation: 19,
	InactiveConcept: 30,
	InactiveRegistered: 31,
	InactiveEnrouteHandedToCarrier: 32,
	InactiveEnrouteSorting: 33,
	InactiveEnrouteDistribution: 34,
	InactiveEnrouteCustoms: 35,
	InactiveDeliveredAtRecipient: 36,
	InactiveDeliveredReadyForPickup: 37,
	InactiveDeliveredPackagePickedUp: 38,
	CreditRejected: 100,
	CreditApproved: 101
};
Z.PendingConcept, Z.PendingRegistered, Z.EnrouteHandedToCarrier, Z.EnrouteSorting, Z.EnrouteDistribution, Z.DeliveredAtCustoms, Z.DeliveredAtRecipient, Z.DeliveredPackagePickedUp, Z.DeliveredReturnShipmentPackagePickedUp, Z.DeliveredAtAgreedLocation, Z.PrintedLetter, Z.PrintedDigitalStamp, Z.InactiveConcept, Z.InactiveRegistered, Z.InactiveEnrouteHandedToCarrier, Z.InactiveEnrouteSorting, Z.InactiveEnrouteDistribution, Z.InactiveEnrouteCustoms, Z.InactiveDeliveredAtRecipient, Z.InactiveDeliveredReadyForPickup, Z.InactiveDeliveredPackagePickedUp;
var Q = {
	MILLIMETER: "mm",
	CENTIMETER: "cm",
	DECIMETER: "dm",
	METER: "m",
	KILOMETER: "km"
}, we = {
	GRAM: "g",
	KILOGRAM: "kg"
}, Te = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs = r();
	})(e, (function() {
		var e = 1e3, t = 6e4, n = 36e5, r = "millisecond", i = "second", a = "minute", o = "hour", s = "day", c = "week", l = "month", u = "quarter", d = "year", f = "date", p = "Invalid Date", m = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, h = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = {
			name: "en",
			weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
			months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
			ordinal: function(e) {
				var t = [
					"th",
					"st",
					"nd",
					"rd"
				], n = e % 100;
				return "[" + e + (t[(n - 20) % 10] || t[n] || t[0]) + "]";
			}
		}, _ = function(e, t, n) {
			var r = String(e);
			return !r || r.length >= t ? e : "" + Array(t + 1 - r.length).join(n) + e;
		}, v = {
			s: _,
			z: function(e) {
				var t = -e.utcOffset(), n = Math.abs(t), r = Math.floor(n / 60), i = n % 60;
				return (t <= 0 ? "+" : "-") + _(r, 2, "0") + ":" + _(i, 2, "0");
			},
			m: function e(t, n) {
				if (t.date() < n.date()) return -e(n, t);
				var r = 12 * (n.year() - t.year()) + (n.month() - t.month()), i = t.clone().add(r, l), a = n - i < 0, o = t.clone().add(r + (a ? -1 : 1), l);
				return +(-(r + (n - i) / (a ? i - o : o - i)) || 0);
			},
			a: function(e) {
				return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
			},
			p: function(e) {
				return {
					M: l,
					y: d,
					w: c,
					d: s,
					D: f,
					h: o,
					m: a,
					s: i,
					ms: r,
					Q: u
				}[e] || String(e || "").toLowerCase().replace(/s$/, "");
			},
			u: function(e) {
				return e === void 0;
			}
		}, y = "en", b = {};
		b[y] = g;
		var ee = "$isDayjsObject", te = function(e) {
			return e instanceof re || !(!e || !e[ee]);
		}, ne = function e(t, n, r) {
			var i;
			if (!t) return y;
			if (typeof t == "string") {
				var a = t.toLowerCase();
				b[a] && (i = a), n && (b[a] = n, i = a);
				var o = t.split("-");
				if (!i && o.length > 1) return e(o[0]);
			} else {
				var s = t.name;
				b[s] = t, i = s;
			}
			return !r && i && (y = i), i || !r && y;
		}, x = function(e, t) {
			if (te(e)) return e.clone();
			var n = typeof t == "object" ? t : {};
			return n.date = e, n.args = arguments, new re(n);
		}, S = v;
		S.l = ne, S.i = te, S.w = function(e, t) {
			return x(e, {
				locale: t.$L,
				utc: t.$u,
				x: t.$x,
				$offset: t.$offset
			});
		};
		var re = function() {
			function g(e) {
				this.$L = ne(e.locale, null, !0), this.parse(e), this.$x = this.$x || e.x || {}, this[ee] = !0;
			}
			var _ = g.prototype;
			return _.parse = function(e) {
				this.$d = function(e) {
					var t = e.date, n = e.utc;
					if (t === null) return /* @__PURE__ */ new Date(NaN);
					if (S.u(t)) return /* @__PURE__ */ new Date();
					if (t instanceof Date) return new Date(t);
					if (typeof t == "string" && !/Z$/i.test(t)) {
						var r = t.match(m);
						if (r) {
							var i = r[2] - 1 || 0, a = (r[7] || "0").substring(0, 3);
							return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, a);
						}
					}
					return new Date(t);
				}(e), this.init();
			}, _.init = function() {
				var e = this.$d;
				this.$y = e.getFullYear(), this.$M = e.getMonth(), this.$D = e.getDate(), this.$W = e.getDay(), this.$H = e.getHours(), this.$m = e.getMinutes(), this.$s = e.getSeconds(), this.$ms = e.getMilliseconds();
			}, _.$utils = function() {
				return S;
			}, _.isValid = function() {
				return this.$d.toString() !== p;
			}, _.isSame = function(e, t) {
				var n = x(e);
				return this.startOf(t) <= n && n <= this.endOf(t);
			}, _.isAfter = function(e, t) {
				return x(e) < this.startOf(t);
			}, _.isBefore = function(e, t) {
				return this.endOf(t) < x(e);
			}, _.$g = function(e, t, n) {
				return S.u(e) ? this[t] : this.set(n, e);
			}, _.unix = function() {
				return Math.floor(this.valueOf() / 1e3);
			}, _.valueOf = function() {
				return this.$d.getTime();
			}, _.startOf = function(e, t) {
				var n = this, r = !!S.u(t) || t, u = S.p(e), p = function(e, t) {
					var i = S.w(n.$u ? Date.UTC(n.$y, t, e) : new Date(n.$y, t, e), n);
					return r ? i : i.endOf(s);
				}, m = function(e, t) {
					return S.w(n.toDate()[e].apply(n.toDate("s"), (r ? [
						0,
						0,
						0,
						0
					] : [
						23,
						59,
						59,
						999
					]).slice(t)), n);
				}, h = this.$W, g = this.$M, _ = this.$D, v = "set" + (this.$u ? "UTC" : "");
				switch (u) {
					case d: return r ? p(1, 0) : p(31, 11);
					case l: return r ? p(1, g) : p(0, g + 1);
					case c:
						var y = this.$locale().weekStart || 0, b = (h < y ? h + 7 : h) - y;
						return p(r ? _ - b : _ + (6 - b), g);
					case s:
					case f: return m(v + "Hours", 0);
					case o: return m(v + "Minutes", 1);
					case a: return m(v + "Seconds", 2);
					case i: return m(v + "Milliseconds", 3);
					default: return this.clone();
				}
			}, _.endOf = function(e) {
				return this.startOf(e, !1);
			}, _.$set = function(e, t) {
				var n, c = S.p(e), u = "set" + (this.$u ? "UTC" : ""), p = (n = {}, n[s] = u + "Date", n[f] = u + "Date", n[l] = u + "Month", n[d] = u + "FullYear", n[o] = u + "Hours", n[a] = u + "Minutes", n[i] = u + "Seconds", n[r] = u + "Milliseconds", n)[c], m = c === s ? this.$D + (t - this.$W) : t;
				if (c === l || c === d) {
					var h = this.clone().set(f, 1);
					h.$d[p](m), h.init(), this.$d = h.set(f, Math.min(this.$D, h.daysInMonth())).$d;
				} else p && this.$d[p](m);
				return this.init(), this;
			}, _.set = function(e, t) {
				return this.clone().$set(e, t);
			}, _.get = function(e) {
				return this[S.p(e)]();
			}, _.add = function(r, u) {
				var f, p = this;
				r = Number(r);
				var m = S.p(u), h = function(e) {
					var t = x(p);
					return S.w(t.date(t.date() + Math.round(e * r)), p);
				};
				if (m === l) return this.set(l, this.$M + r);
				if (m === d) return this.set(d, this.$y + r);
				if (m === s) return h(1);
				if (m === c) return h(7);
				var g = (f = {}, f[a] = t, f[o] = n, f[i] = e, f)[m] || 1, _ = this.$d.getTime() + r * g;
				return S.w(_, this);
			}, _.subtract = function(e, t) {
				return this.add(-1 * e, t);
			}, _.format = function(e) {
				var t = this, n = this.$locale();
				if (!this.isValid()) return n.invalidDate || p;
				var r = e || "YYYY-MM-DDTHH:mm:ssZ", i = S.z(this), a = this.$H, o = this.$m, s = this.$M, c = n.weekdays, l = n.months, u = n.meridiem, d = function(e, n, i, a) {
					return e && (e[n] || e(t, r)) || i[n].slice(0, a);
				}, f = function(e) {
					return S.s(a % 12 || 12, e, "0");
				}, m = u || function(e, t, n) {
					var r = e < 12 ? "AM" : "PM";
					return n ? r.toLowerCase() : r;
				};
				return r.replace(h, (function(e, r) {
					return r || function(e) {
						switch (e) {
							case "YY": return String(t.$y).slice(-2);
							case "YYYY": return S.s(t.$y, 4, "0");
							case "M": return s + 1;
							case "MM": return S.s(s + 1, 2, "0");
							case "MMM": return d(n.monthsShort, s, l, 3);
							case "MMMM": return d(l, s);
							case "D": return t.$D;
							case "DD": return S.s(t.$D, 2, "0");
							case "d": return String(t.$W);
							case "dd": return d(n.weekdaysMin, t.$W, c, 2);
							case "ddd": return d(n.weekdaysShort, t.$W, c, 3);
							case "dddd": return c[t.$W];
							case "H": return String(a);
							case "HH": return S.s(a, 2, "0");
							case "h": return f(1);
							case "hh": return f(2);
							case "a": return m(a, o, !0);
							case "A": return m(a, o, !1);
							case "m": return String(o);
							case "mm": return S.s(o, 2, "0");
							case "s": return String(t.$s);
							case "ss": return S.s(t.$s, 2, "0");
							case "SSS": return S.s(t.$ms, 3, "0");
							case "Z": return i;
						}
						return null;
					}(e) || i.replace(":", "");
				}));
			}, _.utcOffset = function() {
				return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
			}, _.diff = function(r, f, p) {
				var m, h = this, g = S.p(f), _ = x(r), v = (_.utcOffset() - this.utcOffset()) * t, y = this - _, b = function() {
					return S.m(h, _);
				};
				switch (g) {
					case d:
						m = b() / 12;
						break;
					case l:
						m = b();
						break;
					case u:
						m = b() / 3;
						break;
					case c:
						m = (y - v) / 6048e5;
						break;
					case s:
						m = (y - v) / 864e5;
						break;
					case o:
						m = y / n;
						break;
					case a:
						m = y / t;
						break;
					case i:
						m = y / e;
						break;
					default: m = y;
				}
				return p ? m : S.a(m);
			}, _.daysInMonth = function() {
				return this.endOf(l).$D;
			}, _.$locale = function() {
				return b[this.$L];
			}, _.locale = function(e, t) {
				if (!e) return this.$L;
				var n = this.clone(), r = ne(e, t, !0);
				return r && (n.$L = r), n;
			}, _.clone = function() {
				return S.w(this.$d, this);
			}, _.toDate = function() {
				return new Date(this.valueOf());
			}, _.toJSON = function() {
				return this.isValid() ? this.toISOString() : null;
			}, _.toISOString = function() {
				return this.$d.toISOString();
			}, _.toString = function() {
				return this.$d.toUTCString();
			}, g;
		}(), ie = re.prototype;
		return x.prototype = ie, [
			["$ms", r],
			["$s", i],
			["$m", a],
			["$H", o],
			["$W", s],
			["$M", l],
			["$y", d],
			["$D", f]
		].forEach((function(e) {
			ie[e[1]] = function(t) {
				return this.$g(t, e[0], e[1]);
			};
		})), x.extend = function(e, t) {
			return e.$i ||= (e(t, re, x), !0), x;
		}, x.locale = ne, x.isDayjs = te, x.unix = function(e) {
			return x(1e3 * e);
		}, x.en = b[y], x.Ls = b, x.p = {}, x;
	}));
})), Ee = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Te()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_nl = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "nl",
			weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
			weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
			weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
			months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),
			monthsShort: "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
			ordinal: function(e) {
				return "[" + e + (e === 1 || e === 8 || e >= 20 ? "ste" : "de") + "]";
			},
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD-MM-YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "over %s",
				past: "%s geleden",
				s: "een paar seconden",
				m: "een minuut",
				mm: "%d minuten",
				h: "een uur",
				hh: "%d uur",
				d: "een dag",
				dd: "%d dagen",
				M: "een maand",
				MM: "%d maanden",
				y: "een jaar",
				yy: "%d jaar"
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), De = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Te()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_it = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "it",
			weekdays: "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split("_"),
			weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
			weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
			months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),
			weekStart: 1,
			monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "tra %s",
				past: "%s fa",
				s: "qualche secondo",
				m: "un minuto",
				mm: "%d minuti",
				h: "un' ora",
				hh: "%d ore",
				d: "un giorno",
				dd: "%d giorni",
				M: "un mese",
				MM: "%d mesi",
				y: "un anno",
				yy: "%d anni"
			},
			ordinal: function(e) {
				return e + "º";
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), Oe = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r(Te()) : typeof define == "function" && define.amd ? define(["dayjs"], r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_locale_fr = r(n.dayjs);
	})(e, (function(e) {
		function t(e) {
			return e && typeof e == "object" && "default" in e ? e : { default: e };
		}
		var n = t(e), r = {
			name: "fr",
			weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
			weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
			weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
			months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),
			monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),
			weekStart: 1,
			yearStart: 4,
			formats: {
				LT: "HH:mm",
				LTS: "HH:mm:ss",
				L: "DD/MM/YYYY",
				LL: "D MMMM YYYY",
				LLL: "D MMMM YYYY HH:mm",
				LLLL: "dddd D MMMM YYYY HH:mm"
			},
			relativeTime: {
				future: "dans %s",
				past: "il y a %s",
				s: "quelques secondes",
				m: "une minute",
				mm: "%d minutes",
				h: "une heure",
				hh: "%d heures",
				d: "un jour",
				dd: "%d jours",
				M: "un mois",
				MM: "%d mois",
				y: "un an",
				yy: "%d ans"
			},
			ordinal: function(e) {
				return "" + e + (e === 1 ? "er" : "");
			}
		};
		return n.default.locale(r, null, !0), r;
	}));
})), ke = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_calendar = r();
	})(e, (function() {
		return function(e, t, n) {
			var r = "h:mm A", i = {
				lastDay: "[Yesterday at] " + r,
				sameDay: "[Today at] " + r,
				nextDay: "[Tomorrow at] " + r,
				nextWeek: "dddd [at] " + r,
				lastWeek: "[Last] dddd [at] " + r,
				sameElse: "MM/DD/YYYY"
			};
			t.prototype.calendar = function(e, t) {
				var r = t || this.$locale().calendar || i, a = n(e || void 0).startOf("d"), o = this.diff(a, "d", !0), s = "sameElse", c = o < -6 ? s : o < -1 ? "lastWeek" : o < 0 ? "lastDay" : o < 1 ? "sameDay" : o < 2 ? "nextDay" : o < 7 ? "nextWeek" : s, l = r[c] || i[c];
				return typeof l == "function" ? l.call(this, n()) : this.format(l);
			};
		};
	}));
})), Ae = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_customParseFormat = r();
	})(e, (function() {
		var e = {
			LTS: "h:mm:ss A",
			LT: "h:mm A",
			L: "MM/DD/YYYY",
			LL: "MMMM D, YYYY",
			LLL: "MMMM D, YYYY h:mm A",
			LLLL: "dddd, MMMM D, YYYY h:mm A"
		}, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d\d/, r = /\d\d?/, i = /\d*[^-_:/,()\s\d]+/, a = {}, o = function(e) {
			return (e = +e) + (e > 68 ? 1900 : 2e3);
		}, s = function(e) {
			return function(t) {
				this[e] = +t;
			};
		}, c = [/[+-]\d\d:?(\d\d)?|Z/, function(e) {
			(this.zone ||= {}).offset = function(e) {
				if (!e || e === "Z") return 0;
				var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
				return n === 0 ? 0 : t[0] === "+" ? -n : n;
			}(e);
		}], l = function(e) {
			var t = a[e];
			return t && (t.indexOf ? t : t.s.concat(t.f));
		}, u = function(e, t) {
			var n, r = a.meridiem;
			if (r) {
				for (var i = 1; i <= 24; i += 1) if (e.indexOf(r(i, 0, t)) > -1) {
					n = i > 12;
					break;
				}
			} else n = e === (t ? "pm" : "PM");
			return n;
		}, d = {
			A: [i, function(e) {
				this.afternoon = u(e, !1);
			}],
			a: [i, function(e) {
				this.afternoon = u(e, !0);
			}],
			S: [/\d/, function(e) {
				this.milliseconds = 100 * e;
			}],
			SS: [n, function(e) {
				this.milliseconds = 10 * e;
			}],
			SSS: [/\d{3}/, function(e) {
				this.milliseconds = +e;
			}],
			s: [r, s("seconds")],
			ss: [r, s("seconds")],
			m: [r, s("minutes")],
			mm: [r, s("minutes")],
			H: [r, s("hours")],
			h: [r, s("hours")],
			HH: [r, s("hours")],
			hh: [r, s("hours")],
			D: [r, s("day")],
			DD: [n, s("day")],
			Do: [i, function(e) {
				var t = a.ordinal, n = e.match(/\d+/);
				if (this.day = n[0], t) for (var r = 1; r <= 31; r += 1) t(r).replace(/\[|\]/g, "") === e && (this.day = r);
			}],
			M: [r, s("month")],
			MM: [n, s("month")],
			MMM: [i, function(e) {
				var t = l("months"), n = (l("monthsShort") || t.map((function(e) {
					return e.slice(0, 3);
				}))).indexOf(e) + 1;
				if (n < 1) throw Error();
				this.month = n % 12 || n;
			}],
			MMMM: [i, function(e) {
				var t = l("months").indexOf(e) + 1;
				if (t < 1) throw Error();
				this.month = t % 12 || t;
			}],
			Y: [/[+-]?\d+/, s("year")],
			YY: [n, function(e) {
				this.year = o(e);
			}],
			YYYY: [/\d{4}/, s("year")],
			Z: c,
			ZZ: c
		};
		function f(n) {
			for (var r = n, i = a && a.formats, o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (function(t, n, r) {
				var a = r && r.toUpperCase();
				return n || i[r] || e[r] || i[a].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (function(e, t, n) {
					return t || n.slice(1);
				}));
			}))).match(t), s = o.length, c = 0; c < s; c += 1) {
				var l = o[c], u = d[l], f = u && u[0], p = u && u[1];
				o[c] = p ? {
					regex: f,
					parser: p
				} : l.replace(/^\[|\]$/g, "");
			}
			return function(e) {
				for (var t = {}, n = 0, r = 0; n < s; n += 1) {
					var i = o[n];
					if (typeof i == "string") r += i.length;
					else {
						var a = i.regex, c = i.parser, l = e.slice(r), u = a.exec(l)[0];
						c.call(t, u), e = e.replace(u, "");
					}
				}
				return function(e) {
					var t = e.afternoon;
					if (t !== void 0) {
						var n = e.hours;
						t ? n < 12 && (e.hours += 12) : n === 12 && (e.hours = 0), delete e.afternoon;
					}
				}(t), t;
			};
		}
		return function(e, t, n) {
			n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (o = e.parseTwoDigitYear);
			var r = t.prototype, i = r.parse;
			r.parse = function(e) {
				var t = e.date, r = e.utc, o = e.args;
				this.$u = r;
				var s = o[1];
				if (typeof s == "string") {
					var c = !0 === o[2], l = !0 === o[3], u = c || l, d = o[2];
					l && (d = o[2]), a = this.$locale(), !c && d && (a = n.Ls[d]), this.$d = function(e, t, n) {
						try {
							if (["x", "X"].indexOf(t) > -1) return /* @__PURE__ */ new Date((t === "X" ? 1e3 : 1) * e);
							var r = f(t)(e), i = r.year, a = r.month, o = r.day, s = r.hours, c = r.minutes, l = r.seconds, u = r.milliseconds, d = r.zone, p = /* @__PURE__ */ new Date(), m = o || (i || a ? 1 : p.getDate()), h = i || p.getFullYear(), g = 0;
							i && !a || (g = a > 0 ? a - 1 : p.getMonth());
							var _ = s || 0, v = c || 0, y = l || 0, b = u || 0;
							return d ? new Date(Date.UTC(h, g, m, _, v, y, b + 60 * d.offset * 1e3)) : n ? new Date(Date.UTC(h, g, m, _, v, y, b)) : new Date(h, g, m, _, v, y, b);
						} catch {
							return /* @__PURE__ */ new Date("");
						}
					}(t, s, r), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(s) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
				} else if (s instanceof Array) for (var p = s.length, m = 1; m <= p; m += 1) {
					o[1] = s[m - 1];
					var h = n.apply(this, o);
					if (h.isValid()) {
						this.$d = h.$d, this.$L = h.$L, this.init();
						break;
					}
					m === p && (this.$d = /* @__PURE__ */ new Date(""));
				}
				else i.call(this, e);
			};
		};
	}));
})), je = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isBetween = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isBetween = function(e, t, r, i) {
				var a = n(e), o = n(t), s = (i ||= "()")[0] === "(", c = i[1] === ")";
				return (s ? this.isAfter(a, r) : !this.isBefore(a, r)) && (c ? this.isBefore(o, r) : !this.isAfter(o, r)) || (s ? this.isBefore(a, r) : !this.isAfter(a, r)) && (c ? this.isAfter(o, r) : !this.isBefore(o, r));
			};
		};
	}));
})), Me = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isLeapYear = r();
	})(e, (function() {
		return function(e, t) {
			t.prototype.isLeapYear = function() {
				return this.$y % 4 == 0 && this.$y % 100 != 0 || this.$y % 400 == 0;
			};
		};
	}));
})), Ne = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isToday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isToday = function() {
				var e = "YYYY-MM-DD", t = n();
				return this.format(e) === t.format(e);
			};
		};
	}));
})), Pe = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_isYesterday = r();
	})(e, (function() {
		return function(e, t, n) {
			t.prototype.isYesterday = function() {
				var e = "YYYY-MM-DD", t = n().subtract(1, "day");
				return this.format(e) === t.format(e);
			};
		};
	}));
})), Fe = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_timezone = r();
	})(e, (function() {
		var e = {
			year: 0,
			month: 1,
			day: 2,
			hour: 3,
			minute: 4,
			second: 5
		}, t = {};
		return function(n, r, i) {
			var a, o = function(e, n, r) {
				r === void 0 && (r = {});
				var i = new Date(e);
				return function(e, n) {
					n === void 0 && (n = {});
					var r = n.timeZoneName || "short", i = e + "|" + r, a = t[i];
					return a || (a = new Intl.DateTimeFormat("en-US", {
						hour12: !1,
						timeZone: e,
						year: "numeric",
						month: "2-digit",
						day: "2-digit",
						hour: "2-digit",
						minute: "2-digit",
						second: "2-digit",
						timeZoneName: r
					}), t[i] = a), a;
				}(n, r).formatToParts(i);
			}, s = function(t, n) {
				for (var r = o(t, n), a = [], s = 0; s < r.length; s += 1) {
					var c = r[s], l = c.type, u = c.value, d = e[l];
					d >= 0 && (a[d] = parseInt(u, 10));
				}
				var f = a[3], p = f === 24 ? 0 : f, m = a[0] + "-" + a[1] + "-" + a[2] + " " + p + ":" + a[4] + ":" + a[5] + ":000", h = +t;
				return (i.utc(m).valueOf() - (h -= h % 1e3)) / 6e4;
			}, c = r.prototype;
			c.tz = function(e, t) {
				e === void 0 && (e = a);
				var n = this.utcOffset(), r = this.toDate(), o = r.toLocaleString("en-US", { timeZone: e }), s = Math.round((r - new Date(o)) / 1e3 / 60), c = i(o, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(r.getTimezoneOffset() / 15) - s, !0);
				if (t) {
					var l = c.utcOffset();
					c = c.add(n - l, "minute");
				}
				return c.$x.$timezone = e, c;
			}, c.offsetName = function(e) {
				var t = this.$x.$timezone || i.tz.guess(), n = o(this.valueOf(), t, { timeZoneName: e }).find((function(e) {
					return e.type.toLowerCase() === "timezonename";
				}));
				return n && n.value;
			};
			var l = c.startOf;
			c.startOf = function(e, t) {
				if (!this.$x || !this.$x.$timezone) return l.call(this, e, t);
				var n = i(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
				return l.call(n, e, t).tz(this.$x.$timezone, !0);
			}, i.tz = function(e, t, n) {
				var r = n && t, o = n || t || a, c = s(+i(), o);
				if (typeof e != "string") return i(e).tz(o);
				var l = function(e, t, n) {
					var r = e - 60 * t * 1e3, i = s(r, n);
					if (t === i) return [r, t];
					var a = s(r -= 60 * (i - t) * 1e3, n);
					return i === a ? [r, i] : [e - 60 * Math.min(i, a) * 1e3, Math.max(i, a)];
				}(i.utc(e, r).valueOf(), c, o), u = l[0], d = l[1], f = i(u).utcOffset(d);
				return f.$x.$timezone = o, f;
			}, i.tz.guess = function() {
				return Intl.DateTimeFormat().resolvedOptions().timeZone;
			}, i.tz.setDefault = function(e) {
				a = e;
			};
		};
	}));
})), Ie = /* @__PURE__ */ C(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n = typeof globalThis < "u" ? globalThis : n || self).dayjs_plugin_utc = r();
	})(e, (function() {
		var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, n = /([+-]|\d\d)/g;
		return function(r, i, a) {
			var o = i.prototype;
			a.utc = function(e) {
				return new i({
					date: e,
					utc: !0,
					args: arguments
				});
			}, o.utc = function(t) {
				var n = a(this.toDate(), {
					locale: this.$L,
					utc: !0
				});
				return t ? n.add(this.utcOffset(), e) : n;
			}, o.local = function() {
				return a(this.toDate(), {
					locale: this.$L,
					utc: !1
				});
			};
			var s = o.parse;
			o.parse = function(e) {
				e.utc && (this.$u = !0), this.$utils().u(e.$offset) || (this.$offset = e.$offset), s.call(this, e);
			};
			var c = o.init;
			o.init = function() {
				if (this.$u) {
					var e = this.$d;
					this.$y = e.getUTCFullYear(), this.$M = e.getUTCMonth(), this.$D = e.getUTCDate(), this.$W = e.getUTCDay(), this.$H = e.getUTCHours(), this.$m = e.getUTCMinutes(), this.$s = e.getUTCSeconds(), this.$ms = e.getUTCMilliseconds();
				} else c.call(this);
			};
			var l = o.utcOffset;
			o.utcOffset = function(r, i) {
				var a = this.$utils().u;
				if (a(r)) return this.$u ? 0 : a(this.$offset) ? l.call(this) : this.$offset;
				if (typeof r == "string" && (r = function(e) {
					e === void 0 && (e = "");
					var r = e.match(t);
					if (!r) return null;
					var i = ("" + r[0]).match(n) || [
						"-",
						0,
						0
					], a = i[0], o = 60 * i[1] + +i[2];
					return o === 0 ? 0 : a === "+" ? o : -o;
				}(r), r === null)) return this;
				var o = Math.abs(r) <= 16 ? 60 * r : r, s = this;
				if (i) return s.$offset = o, s.$u = r === 0, s;
				if (r !== 0) {
					var c = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
					(s = this.local().add(o + c, e)).$offset = o, s.$x.$localOffset = c;
				} else s = this.utc();
				return s;
			};
			var u = o.format;
			o.format = function(e) {
				var t = e || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
				return u.call(this, t);
			}, o.valueOf = function() {
				var e = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
				return this.$d.valueOf() - 6e4 * e;
			}, o.isUTC = function() {
				return !!this.$u;
			}, o.toISOString = function() {
				return this.toDate().toISOString();
			}, o.toString = function() {
				return this.toDate().toUTCString();
			};
			var d = o.toDate;
			o.toDate = function(e) {
				return e === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : d.call(this);
			};
			var f = o.diff;
			o.diff = function(e, t, n) {
				if (e && this.$u === e.$u) return f.call(this, e, t, n);
				var r = this.local(), i = a(e).local();
				return f.call(r, i, t, n);
			};
		};
	}));
}));
Ee(), De(), Oe();
var $ = /* @__PURE__ */ w(Te(), 1), Le = /* @__PURE__ */ w(ke(), 1), Re = /* @__PURE__ */ w(Ae(), 1), ze = /* @__PURE__ */ w(je(), 1), Be = /* @__PURE__ */ w(Me(), 1), Ve = /* @__PURE__ */ w(Ne(), 1), He = /* @__PURE__ */ w(Pe(), 1), Ue = /* @__PURE__ */ w(Fe(), 1), We = /* @__PURE__ */ w(Ie(), 1);
$.default.extend(Re.default), $.default.extend(Be.default), $.default.extend(Le.default), $.default.extend(We.default), $.default.extend(ze.default), $.default.extend(Ve.default), $.default.extend(He.default), $.default.extend(Ue.default), $.default.locale("nl"), $.default.tz.setDefault("Europe/Amsterdam");
var Ge = $.default;
function Ke(e, t, n) {
	let r = t.split(/[.[\]]/).filter(Boolean).reduce((e, t) => e?.[t], e);
	return r === void 0 ? n : r;
}
var qe = (e, t, n) => {
	let r = t.split("."), i = r.pop(), a = /\[(\d+)\]/, o = e;
	for (let e of r) o = o[e] ??= {};
	let s = i.match(a);
	if (s) {
		let t = Number(s[1]), r = i.replace(a, "");
		return o[r] = Array.isArray(o[r]) ? o[r] : [], o[r][t] = n, e;
	}
	return o[i] = n, e;
}, Je = (e) => ({ ...e }), Ye = (e, t) => Object.keys(e).reduce((n, r) => (t.includes(r) || (n[r] = e[r]), n), {}), Xe = (e) => {
	function t(e, n, r, i = "") {
		let a = [i, n].filter((e) => e).join(".");
		return typeof r == "object" && !Array.isArray(r) ? Object.keys(r).reduce((e, n) => t(e, n, r[n], a), e) : Object.assign(e, { [a]: r });
	}
	return Object.keys(e).reduce((n, r) => t(n, r, e[r]), {});
}, Ze = (e, t) => t.reduce((t, n) => {
	let r = Ke(e, n);
	return r !== void 0 && (t[n] = r), t;
}, {}), Qe = {
	clone: Je,
	get: Ke,
	pick: Ze,
	pickRename: (e, t) => {
		let n = Ze(e, Object.keys(t));
		return Object.entries(t).reduce((e, [t, r]) => {
			let i = n[t];
			return i !== void 0 && (e[r] = i), e;
		}, {});
	},
	flatten: Xe,
	filterKeysFromObject: Ye,
	set: qe
}, $e = (e, t) => e.localeCompare(t), et = (e, t) => t.localeCompare(e), tt = (e) => !/^[\p{L}\p{N}]/u.test(e), nt = {
	ascending: $e,
	descending: et,
	byProperty: (e, t = { order: "ASC" }) => (n, r) => {
		let i = Qe.get(n, e), a = Qe.get(r, e), o = t.order === "ASC" ? $e : et;
		if (!i) return t.order === "ASC" ? 1 : -1;
		if (!a) return t.order === "ASC" ? -1 : 1;
		if (t.specialCharactersLast) {
			let e = tt(i);
			if (e !== tt(a)) return e ? 1 : -1;
		}
		return o(i, a);
	}
}, rt = {
	byValue: (e = []) => (t, n) => {
		let r = e.indexOf(t), i = e.indexOf(n);
		return r === -1 && i === -1 ? 0 : r === -1 ? 1 : i === -1 ? -1 : r - i;
	},
	byProperty: (e, t = []) => (n, r) => {
		let i = Qe.get(n, e) ?? "", a = Qe.get(r, e) ?? "", o = t.indexOf(i), s = t.indexOf(a);
		return o === -1 && s === -1 ? 0 : o === -1 ? 1 : s === -1 ? -1 : o - s;
	}
}, it = { sortByDate: (e, t, n = { order: "ASC" }) => e.sort((e, r) => {
	let i = Ge(Qe.get(e, t)).unix(), a = Ge(Qe.get(r, t)).unix();
	return n.order === "ASC" ? i - a : a - i;
}) }, at = (e, t) => e - t, ot = (e, t) => t - e, st = {
	numeric: {
		ascending: at,
		descending: ot,
		trailingZero: (e, t) => e === 0 ? 1 : t === 0 ? -1 : e - t,
		byProperty: (e, t = { order: "ASC" }) => (n, r) => {
			let i = Qe.get(n, e), a = Qe.get(r, e);
			if (i === a) return 0;
			let o = t.order === "ASC" ? at : ot;
			return i == null ? t.order === "ASC" ? 1 : -1 : a == null ? t.order === "ASC" ? -1 : 1 : o(i, a);
		}
	},
	alphabetical: nt,
	customOrder: rt,
	date: it
};
Q.MILLIMETER, Q.CENTIMETER, Q.DECIMETER, Q.METER, Q.KILOMETER, we.GRAM, we.KILOGRAM, Q.MILLIMETER, Q.CENTIMETER, Q.DECIMETER, Q.METER, Q.KILOMETER, we.GRAM, we.KILOGRAM;
//#endregion
//#region src/configs/initial-config.ts
var ct = {
	addressBook: {
		enableCollectAddress: !1,
		enableCreateReturnShipments: !1
	},
	applications: {
		backoffice: { enabled: !1 },
		webshop: { enabled: !1 },
		faq: { enabled: !1 },
		developerPortal: { enabled: !1 },
		corporate: { enabled: !1 },
		consumerPortal: { enabled: !1 }
	},
	collectTrip: { enabled: !1 },
	contract: {
		type: "MAIN",
		carrier: "POSTNL"
	},
	carrierSortOrder: [],
	proposition: {
		id: 0,
		key: "",
		name: "",
		shortName: ""
	},
	countryCode: "",
	subscriptions: {
		bundle: { enabled: !1 },
		myAnalytics: {
			enabled: !1,
			availableDashboards: [],
			usps: {}
		},
		myContracts: { enabled: !1 },
		myOrders: {
			enabled: !1,
			usps: {}
		},
		myScanAndPrint: { enabled: !1 },
		myReturns: { enabled: !1 },
		orderRules: { maxAmount: {
			default: 0,
			start: 5,
			plus: 10
		} },
		shippingRules: {
			countryCodes: [],
			regionCodes: [],
			maxAmount: 0
		}
	},
	billing: {
		allowDisablingInvoiceEmails: !1,
		sendsInvoiceEmailReminders: !1,
		paymentProvider: "",
		ibanExample: "",
		bankMandate: { cocRequired: !1 },
		vetting: {
			vatNumber: !1,
			routingNumber: !1,
			pecEmail: !1
		},
		newInvoiceDates: {
			weekly: "",
			monthly: ""
		},
		invoiceFormats: []
	},
	brackets: {
		availableForCarriers: [],
		weightTiers: {}
	},
	contracts: {
		available: [],
		availableForCustomCredentials: [],
		enablePostNLCustomContract: !1,
		inbound: { default: {} },
		outbound: { default: {} }
	},
	content: {},
	companyDetails: {
		billing: {
			coc: "",
			vatNumber: ""
		},
		contact: {
			phoneNumber: { enabled: !1 },
			whatsapp: { enabled: !1 }
		},
		address: {
			city: "",
			company: "",
			countryCode: "",
			email: "",
			houseNumber: "",
			person: "",
			phone: "",
			postalCode: "",
			street: ""
		},
		returnAddress: {
			city: "",
			company: "",
			countryCode: "",
			email: "",
			houseNumber: "",
			person: "",
			phone: "",
			postalCode: "",
			street: ""
		}
	},
	centerOfCountry: {
		latitude: 0,
		longitude: 0,
		zoom: 8
	},
	assets: {
		url: "",
		logo: {
			medium: { url: "" },
			small: { url: "" }
		},
		exampleDocuments: {
			products: { csv: "" },
			orders: { csv: "" },
			ordersCsvImport: { default: { csv: "" } },
			shipments: { csv: "" },
			addresses: { default: { csv: "" } }
		}
	},
	rules: {
		requiresEmailRecipient: !0,
		country: {
			withAddressFinder: [],
			withPalletDelivery: [],
			withRecommendedPhoneNumber: [],
			withRequiredPhoneNumber: [],
			withRequiredEmail: [],
			withRequiredCompany: [],
			withRequiredLabelDescription: [],
			withRequiredHeight: [],
			withRequiredLength: [],
			withRequiredWidth: [],
			withPossibleReturn: [],
			withPartnerLinks: [],
			withSeparatedStreetAndNumber: []
		},
		carrier: {
			withRequiredPhoneNumber: [],
			withRequiredEmail: [],
			withRequiredCompany: [],
			withRecommendedPhoneNumber: [],
			withRequiredHeight: [],
			withRequiredLength: [],
			withRequiredWidth: [],
			withRequiredLabelDescription: [],
			withRequiredWeight: []
		}
	},
	enableAcademy: !1,
	useToponymicAddressLabels: !1,
	enablePrinterlessReturn: !1,
	enableLogoOnLabel: !1,
	enableMyParcelAsReturnAddress: !1,
	enableOptionToHideMyParcelLogo: !1,
	enableShipmentEstimate: !1,
	enableCompanyDetailsEdit: !1,
	enableCompanyContactVatNumberNote: !1,
	enableContactChamberOfCommerce: !1,
	enableContactCompanyName: !1,
	enableContactSdi: !1,
	enableContactVatNumber: !1,
	enableVATSupport: !1,
	enableVATSupportNote: !1,
	enableSDISupport: !1,
	enableRetailLocations: !1,
	enableLocationFinder: !1,
	enableFulfilment: !1,
	enableTellAFriend: !1,
	enableReturnContributions: [],
	enableSalesChannels: !1,
	availableSalesChannels: [],
	enableLabelPackages: !1,
	notifications: { emails: { enableInternational: !1 } },
	support: {
		flow: "basic",
		availableTypes: []
	},
	integrations: { available: [] },
	weightCategories: {},
	tools: {
		googleTagManager: {
			enabled: !1,
			id: "",
			url: ""
		},
		appcues: {
			enabled: !1,
			id: "",
			enableLaunchpad: !1
		},
		cookieConsent: {
			type: "cookiebot",
			enabled: !1,
			id: ""
		},
		hotjar: {
			enabled: !1,
			id: "",
			enableFeedbackModal: !1
		},
		salesforce: { enabled: !1 }
	},
	browserExtension: { enabled: !1 },
	deliveryOptions: {
		mondayDelivery: !1,
		dropOffDays: []
	},
	settings: {
		enableIntegrations: !1,
		companyContact: {
			additionalProperties: [],
			requiredProperties: []
		},
		export: { availableProperties: [] },
		rules: {
			enableOrderRules: !1,
			enableReturnRules: !1,
			enableShipmentRules: !1
		},
		shop: { enableReturns: !1 }
	},
	orders: { filters: {
		carriers: [],
		packageTypes: [],
		regionCodes: []
	} },
	shipments: {
		hasShipmentsOverview: !1,
		hasPriorityDelivery: !1,
		enableInternational: !1,
		enableCsvImport: !0,
		enablePallet: !1,
		enableReturn: !0,
		enableGoodsImportExport: !1,
		enableSocialShipping: !0,
		filters: {
			packageTypes: [],
			regionCodes: []
		}
	},
	rates: { subjects: [] }
}, lt = a("propositionStore", () => {
	let e = r(ct);
	return {
		propositionConfig: e,
		hasAdvancedSupportFlow: t(() => e.value.support.flow === "advanced"),
		hasBasicSupportFlow: t(() => e.value.support.flow === "basic"),
		hasBolAvailableAsCustomCredentials: t(() => !!e.value.contracts.availableForCustomCredentials.find((e) => e.carrier.name === "BOL")),
		availableContractsWithHandoverTime: t(() => e.value.contracts.available.filter(({ hasCutoffTime: e }) => e).sort(st.customOrder.byProperty("carrier.name", e.value.carrierSortOrder))),
		isMyParcelBe: t(() => e.value.proposition.key === "myparcel-belgie"),
		isMyParcelNl: t(() => e.value.proposition.key === "myparcel-nederland"),
		setProposition: (t) => {
			e.value = t;
		}
	};
}), ut = () => {
	let e = lt(), { propositionConfig: t, hasAdvancedSupportFlow: r, hasBasicSupportFlow: a, hasBolAvailableAsCustomCredentials: o, availableContractsWithHandoverTime: s, isMyParcelBe: c, isMyParcelNl: l } = i(e);
	return {
		proposition: n(t),
		hasAdvancedSupportFlow: r,
		hasBasicSupportFlow: a,
		hasBolAvailableAsCustomCredentials: o,
		availableContractsWithHandoverTime: s,
		isMyParcelBe: c,
		isMyParcelNl: l,
		setProposition: e.setProposition,
		getInboundContract: (e) => t.value.contracts.inbound[e] || t.value.contracts.inbound.default,
		getOutboundContract: (e) => t.value.contracts.outbound[e] || t.value.contracts.outbound.default,
		isCountryOfOrigin: (e) => t.value.countryCode === e,
		getIntegration: (e) => t.value.integrations.available.find((t) => t.name === e),
		getAvailableContractByCarrierName: (e) => t.value.contracts.available.find((t) => t.carrier.name === e)
	};
}, dt = (e) => ({ install: () => {
	let { setProposition: t } = ut();
	t(e);
} }), ft = (e, t, n, r) => {
	let { proposition: i } = ut();
	return n(i.value) ? !0 : r;
}, pt = (e, t) => (n, r) => ft(n, r, e, t);
//#endregion
export { ae as ApplicationSchema, te as CarrierFeaturesSchema, c as CarrierNameSchema, ie as ContentConfigSchema, h as ContractConfigurationParameterNameSchema, g as ContractConfigurationParametersSchema, x as ContractSchema, S as DefaultContractSchema, f as DeliveryTypeSchema, l as EcommerceSalesChannelSchema, re as InternationalizationSchema, m as MetadataKeySchema, u as PackageTypeSchema, se as PropositionConfigSchema, s as PropositionEnvironmentSchema, oe as RatesSubjectSchema, d as RegionCodeSchema, p as ShipmentOptionSchema, ne as SurchargeSchema, v as UspMyAnalyticsSchema, y as UspMyContractsSchema, b as UspMyOrdersSchema, _ as UspMyReturnsSchema, ee as UspMyScanAndPrintSchema, pt as createPropositionGuard, dt as createPropositionPlugin, le as getProposition, o as propositionEnvironments, ft as propositionGuard, ut as useProposition };
